import { defineComponent, onMounted, ref } from 'vue'
import { NoticeBar as VanNoticeBar } from 'vant'
import { getApiV1LiveTopAd } from '@/api/sdk.gen'
import type { LiveTopAd } from '@/api/types.gen'

/**
 * 直播顶部广告位横条：白底红字加粗，从右到左跑马灯滚动。
 * 用于首页 / 直播页的视频容器内，绝对定位贴顶（样式见 vant-override.css）。
 * 仅在后台 enabled=true 且 text 非空时渲染。
 */
const LiveTopAdBar = defineComponent({
  name: 'LiveTopAdBar',
  setup() {
    const ad = ref<LiveTopAd | null>(null)

    onMounted(async () => {
      try {
        const res = await getApiV1LiveTopAd()
        ad.value = res.data?.data ?? null
      } catch {
        ad.value = null
      }
    })

    return () => {
      if (!ad.value?.enabled || !ad.value.text) return null
      return (
        <VanNoticeBar
          class="live-top-ad-bar"
          text={ad.value.text}
          background="#fff"
          color="#ee0a24"
        />
      )
    }
  },
})

export default LiveTopAdBar
